import { ReactComponent as PlaceSvg } from '@/commons/icons/table/place.svg';
import "./index.less"

interface Iprops {
    onClick?: (e) => void
}

export default function PlaceButton(props: Iprops) {
    return (
        <div
            className="place-button"
            onClick={(e) => {
                if (props?.onClick) {
                    props.onClick(e)
                }
            }}
        >
            <PlaceSvg className="place-icon" />
            <div className="place-text">布置</div>
        </div>
    )
}